module.exports = __webpack_public_path__ + "media/images/featured-kumu-afe46b9d736fa3a835f0d57b0bf9a490.png";